module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M26 14h-2v-4c0-5.524-4.476-10-10-10S4 4.476 4 10v4H2c-1.106 0-2 1.094-2 2.2V30c0 1.106.894 2 2 2h24c1.106 0 2-.894 2-2V16.2c0-1.106-.894-2.2-2-2.2zM14 4c3.308 0 6 2.692 6 6v4H8v-4c0-3.308 2.692-6 6-6z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/lock-3.js
// module id = 1245
// module chunks = 14